/**
 * Created by joellee on 11/10/15.
 */
dealershipModule.directive('settingsSummary', function factory() {
    return {
        templateUrl: 'app/modules/dealership/directives/settings-summary-directive.html',
        replace: true,
        //transclude: false,
        restrict: 'E',
        controller: 'SettingsSummaryController'
    };
});